import { Listener } from 'history';
import { useMount } from 'react-use';
import { BrowserHistory } from 'RtUi/app/@RtUi/lib/browser';

export const useBrowserEffect = (listener: Listener) => {
	useMount(() => {
		return BrowserHistory.listen(listener);
	});
};
